<template>
    <router-link :to="{name:'settings.offline'}" v-if="showBanner" class="offline-banner text-center white-text">
        <p class="z-depth-1">You're in <strong>encrypted offline mode</strong></p>
    </router-link>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'offline-mode',
    computed: {
      ...mapGetters({
        offlineMode: 'auth/offlineMode',
        loggedin: 'auth/loggedin',
      }),
      showBanner() {
        return this.offlineMode && this.loggedin;
      }
    },
    methods: {
      ...mapActions({
        logout: 'auth/logout',
      }),
      logoutUser() {
        this.logout().then(() => {
          this.$router.push({name: 'login'});
          //return document.location.reload();
        });
        //this.$router.push({path: '/login'});
      }
    },
  };
</script>

<style scoped>
    div.loading {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.5;
        height: 100%;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/OfflineMode.vue